import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { faEye, faInfoCircle, faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Table from "../../common/Table";

const IndicatorsTable = ({ indicators, locale, onEdit, onDelete }) => {
  const intl = useIntl();
  const [previewQuestion, setPreviewQuestion] = useState(undefined);

  return (
    <>
      {previewQuestion && (
        <Modal show size="xl">
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage id="question.preview" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Image fluid src={previewQuestion.previewImageData} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setPreviewQuestion(undefined)}>
              <FormattedMessage id="app.common.Close" />
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Table
        striped
        hover
        columns={[
          {
            name: "indicatorId",
            labelKey: "indicator.management.indicator",
            customBodyRenderer: (indicator) => (
              <span className="text-nowrap">
                {`${indicator.name[locale]} (ID: ${indicator.indicatorId}) `}
                <OverlayTrigger
                  placement="auto"
                  overlay={
                    <Tooltip id={`tooltip_longname_${indicator.id}`}>
                      <div className="text-start" dangerouslySetInnerHTML={{ __html: indicator.longName[locale] }}></div>
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </OverlayTrigger>
              </span>
            )
          },
          {
            name: "result",
            labelKey: "indicator.management.result",
            customBodyRenderer: (indicator) => (
              <span>
                {indicator.result ? `${indicator.result.name[locale]} ` : ""}
                {indicator.result && indicator.result.description[locale] && (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip_${indicator.id}${indicator.result.id}`}>
                        <span dangerouslySetInnerHTML={{ __html: indicator.result.description[locale] }} />
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </OverlayTrigger>
                )}
              </span>
            )
          },
          {
            name: "actionField",
            labelKey: "indicator.management.action.field.or.fields",
            customBodyRenderer: (indicator) => indicator.result?.actionFields?.map((af) => af.name[locale]).join(", ")
          },
          {
            name: "questions",
            labelKey: "indicator.management.table.header.questions",
            customBodyRenderer: (indicator) => {
              const indicatorQuestions = [];
              //questions ? questions.filter(q =>
              // q.question.indicators.some(curIndicator =>
              // curIndicator.identifier === indicator.id)) : [];
              indicator.libraryQuestionDe && indicatorQuestions.push(indicator.libraryQuestionDe);
              indicator.libraryQuestionEn && indicatorQuestions.push(indicator.libraryQuestionEn);

              return (
                indicatorQuestions && (
                  <ul className="list-unstyled mb-0">
                    {indicatorQuestions.map((q) => (
                      <li key={q.id}>
                        {`${q.name} `}
                        {q.previewImageData && (
                          <Button
                            variant="link"
                            title={intl.formatMessage({ id: "indicator.management.question.preview" })}
                            onClick={() => setPreviewQuestion(q)}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        )}
                      </li>
                    ))}
                  </ul>
                )
              );
            }
          },
          {
            name: "management",
            labelKey: "app.common.title.actions",
            className: "actions",
            actions: [
              {
                code: "edit",
                labelKey: "app.common.action.edit",
                icon: faPencilAlt,
                onClick: (indicator) => onEdit(indicator)
              },
              {
                code: "delete",
                labelKey: "app.common.action.delete",
                className: "text-danger",
                icon: faTrash,
                onClick: (role) => onDelete(role.id)
              }
            ]
          }
        ]}
        data={indicators}
      />
    </>
  );
};

IndicatorsTable.propTypes = {
  indicators: PropTypes.arrayOf(PropTypes.object),
  questions: PropTypes.arrayOf(PropTypes.object),
  locale: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};

export default IndicatorsTable;
